import { useCallback } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/landing/Hero";
import { WhyCollaborate } from "@/components/landing/WhyCollaborate";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { TiersSection } from "@/components/landing/TiersSection";
import { WhatWeLookFor } from "@/components/landing/WhatWeLookFor";
import { ProductSection } from "@/components/landing/ProductSection";
import { MissionSection } from "@/components/landing/MissionSection";
import { PartnersSection } from "@/components/landing/PartnersSection";
import { Faq } from "@/components/landing/Faq";
import { ApplyForm } from "@/components/landing/ApplyForm";

export default function Landing() {
  const scrollToApply = useCallback(() => {
    document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="grain min-h-screen bg-[#050505]">
      <Navbar onApply={scrollToApply} />
      <main>
        <Hero onApply={scrollToApply} />
        <WhyCollaborate />
        <HowItWorks />
        <TiersSection />
        <WhatWeLookFor />
        <ProductSection />
        <PartnersSection />
        <Faq />
        <MissionSection />
        <ApplyForm />
      </main>
      <Footer />
    </div>
  );
}
